import { AxiosEngine } from './AxiosEngine';

// add ${newEngine} class
export const ENGINES = {
  AXIOS: AxiosEngine
};

export type EngineNames = keyof typeof ENGINES
